export function packSizeFromItem(item) {
  if (Number(item.packSize)) return Number(item.packSize);

  const match = String(item.variationName || '').match(/(\d+)/);
  return match ? parseInt(match[1], 10) : 1;
}

export function totalCartKits(cart = []) {
  return cart.reduce((sum, item) => {
    const packSize = packSizeFromItem(item);
    return sum + packSize * Number(item.quantity || 0);
  }, 0);
}